function isUsableImageUrl(src) {
  return Boolean(src) && !src.includes('medium.com/_/stat');
}

function extractImageFromHtml(html) {
  if (!html) return null;

  if (typeof DOMParser !== 'undefined') {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const images = Array.from(doc.querySelectorAll('img'));
    const image = images.find((img) => {
      const src = img.getAttribute('src');
      const width = Number(img.getAttribute('width'));
      const height = Number(img.getAttribute('height'));

      return isUsableImageUrl(src) && width !== 1 && height !== 1;
    });

    if (image) return image.getAttribute('src');
  }

  const imageRegex = /<img\b[^>]*\bsrc=(["'])(.*?)\1/gi;
  let match = imageRegex.exec(html);

  while (match) {
    if (isUsableImageUrl(match[2])) return match[2];
    match = imageRegex.exec(html);
  }

  return null;
}

function stripHtmlTags(value) {
  return value.replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
}

function extractFirstHeadingFromHtml(html) {
  if (!html) return null;

  if (typeof DOMParser !== 'undefined') {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const heading = doc.querySelector('h1, h2, h3');
    const text = heading?.textContent?.trim();

    return text || null;
  }

  const headingMatch = html.match(/<h[1-3]\b[^>]*>([\s\S]*?)<\/h[1-3]>/i);

  if (!headingMatch) return null;

  return stripHtmlTags(headingMatch[1]) || null;
}

export function extractMediumPostImage(post) {
  if (isUsableImageUrl(post?.thumbnail)) return post.thumbnail;

  return (
    extractImageFromHtml(post?.content) ||
    extractImageFromHtml(post?.description)
  );
}

export function getMediumPostTitle(post) {
  return (
    extractFirstHeadingFromHtml(post?.content) ||
    extractFirstHeadingFromHtml(post?.description) ||
    post?.title ||
    ''
  );
}
